import { route } from './route';
import { AITHORA_PREFIX } from './prefix';
import type {
  MyDayAddItemBody,
  MyDayAddItemResponse,
  MyDayEventBody,
  MyDayEventResponse,
  MyDayIndependenceResponse,
  MyDayIntentResponse,
  MyDayPatchItemBody,
  MyDayResponse,
  MyDaySuggestionsResponse,
} from './myday-types';

const A = AITHORA_PREFIX;

// My day (src/aithora/v3/worklist/my-day.ts). Every route promises the `real` flag.
// personId omitted means the caller's own day. The server allows the person themselves
// and staff who care for them; Aithora platform staff and admin tokens never.

/** GET /my-day?personId=: the day, with its items' states and pending suggestions. */
export const myDay = route<MyDayResponse, { personId?: string }>()('GET', `${A}/my-day`, { honest: true });

/** POST /my-day/items: the person adds their own (SELF); staff add from the care plan. */
export const myDayAddItem = route<MyDayAddItemResponse, void, MyDayAddItemBody>()('POST', `${A}/my-day/items`, { honest: true });

/** PATCH /my-day/items/:id: edit or retire an item. */
export const myDayPatchItem = route<{ real: true; updated: true }, void, MyDayPatchItemBody>()('PATCH', `${A}/my-day/items/:id`, { honest: true });

/** POST /my-day/events: a tap (done, done with help, undo, a glass of water). */
export const myDayEvent = route<MyDayEventResponse, void, MyDayEventBody>()('POST', `${A}/my-day/events`, { honest: true });

/** POST /my-day/intent: Atlas's plain-words path ("I took my pills"). */
export const myDayIntent = route<MyDayIntentResponse, void, { personId?: string; utterance: string }>()('POST', `${A}/my-day/intent`, { honest: true });

/** GET /my-day/suggestions?personId=: the person's pending ones, or what family sent. */
export const myDaySuggestions = route<MyDaySuggestionsResponse, { personId?: string }>()('GET', `${A}/my-day/suggestions`, { honest: true });

/** POST /my-day/suggestions: family suggest an item. */
export const myDaySuggest = route<{ real: true; id: string; status: 'PENDING' }, void, { personId: string; label: string; category?: string; dueTime?: string | null }>()(
  'POST', `${A}/my-day/suggestions`, { honest: true });

/** POST /my-day/suggestions/:id/decide {accept}: only the person decides. */
export const myDayDecide = route<{ real: true; status: 'ACCEPTED' | 'DECLINED'; itemId: string | null }, void, { accept: boolean }>()(
  'POST', `${A}/my-day/suggestions/:id/decide`, { honest: true });

/** GET /my-day/independence?personId=&weeks=: weekly done vs done with help. */
export const myDayIndependence = route<MyDayIndependenceResponse, { personId?: string; weeks?: number }>()('GET', `${A}/my-day/independence`, { honest: true });
